import { useReactFlow } from '@xyflow/react';
import dagre from '@dagrejs/dagre';
import React, { useCallback } from 'react';

const dagreGraph = new dagre.graphlib.Graph().setDefaultEdgeLabel(() => ({}));

export const useLayoutedElementsDagre = () => {
    const { getNodes, setNodes, getEdges, fitView } = useReactFlow();

    const getLayoutedElements = useCallback((direction = 'TB') => {
        const nodes = getNodes();
        const edges = getEdges();

        const isHorizontal = direction === 'LR';
        dagreGraph.setGraph({ rankdir: direction });

        nodes.forEach((node) => {
            dagreGraph.setNode(node.id, { width: node.measured?.width, height: node.measured?.height });
        });

        edges.forEach((edge) => {
            dagreGraph.setEdge(edge.source, edge.target);
        });

        dagre.layout(dagreGraph);

        const newNodes = nodes.map((node) => {
            const nodeWithPosition = dagreGraph.node(node.id);
            const newNode = {
                ...node,
                targetPosition: isHorizontal ? 'left' : 'top',
                sourcePosition: isHorizontal ? 'right' : 'bottom',
                // We are shifting the dagre node position (anchor=center center) to the top left
                // so it matches the React Flow node anchor point (top left).
                position: {
                    x: nodeWithPosition.x - node.measured?.width / 2,
                    y: nodeWithPosition.y - node.measured?.height / 2,
                },
            };

            return newNode;
        });

        setNodes(nodes.map(n => {
            const child = newNodes.find(c => c.id == n.id);

            return {
                ...n,
                position: child.position
            }
        }));
        window.requestAnimationFrame(() => {
            fitView();
        });
    }, []);

    return { getLayoutedElements };
};